import { useCallback, useState } from 'react'

/**
 * Hook that re-throws errors during render so the nearest ErrorBoundary catches them.
 *
 * Usage in async code (useEffect, event handlers):
 *   const throwError = useErrorHandler()
 *   try { await fetchData() } catch (e) { throwError(e) }
 *
 * Only use for fatal/unrecoverable errors. For recoverable ones, keep using local error state.
 */
export function useErrorHandler(): (error: unknown) => void {
  const [, setState] = useState()

  return useCallback((error: unknown) => {
    setState(() => {
      throw error instanceof Error ? error : new Error(String(error))
    })
  }, [])
}
